// extracted by mini-css-extract-plugin
export default {"PersistentSection":"PersistentSection_PersistentSection__+tBRg","PersistentSection-toolbar":"PersistentSection_PersistentSection-toolbar__0200g"};